import { render, staticRenderFns } from "./TelegramChatTopics.vue?vue&type=template&id=2a349bb8&lang=pug&"
import script from "./TelegramChatTopics.vue?vue&type=script&lang=js&"
export * from "./TelegramChatTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports